import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ApiHandlerService } from '../../../../core/api-handlers';
import { Logger } from '../../../../core/logger/logger.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';
import { ToastsService } from 'projects/b2c/src/app/core/services/toasts.service';

declare var $: any;
const log = new Logger('auth/ForgotPasswordComponent');


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  private subSunk = new SubSink();
  forgotForm: FormGroup;
  submitted: boolean = false;
  id:any;
  constructor(
    private apiHandlerService: ApiHandlerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.subSunk.sink = this.activatedRoute.queryParams.subscribe(queryParams => {
      if(queryParams && queryParams.token){
        this.id = JSON.parse(atob(queryParams.token))
        if(this.id == undefined || this.id == "undefined")
          this.router.navigate(['/'])
      }else{
        this.router.navigate(['/'])
      }
		
		});
    this.createforgotForm();
  }

  hasError = (controlName: string, errorName: string) => {
    return ((this.submitted || this.forgotForm.controls[controlName].touched) && this.forgotForm.controls[controlName].hasError(errorName));
  }

  onForgot() {
    this.submitted = true;
    if (this.forgotForm.invalid) {
      return;
    }
    const reqBody = Object.assign({}, this.forgotForm.value);
    reqBody.id = this.id;
    delete reqBody.confirmPassword;
    this.apiHandlerService.apiHandler('updatePassword', 'post', {}, {}, reqBody)
      .subscribe(resp => {
        if (resp.statusCode==200 || resp.statusCode==201) {
          this.toastService.toast({type:"success",text:"Password changed successfully.. Pls login to application"})        
          this.cdr.detectChanges();
          this.router.navigate(['/']);  
      }else{
          this.toastService.toast({type:"error",text:"Something went wrong!!, please try later"})
        }
      })
  }

  createforgotForm(): void {
    this.forgotForm = this.formBuilder.group({
     // email: new FormControl('test@gmail.com', [Validators.required, Validators.email, Validators.maxLength(40)])
      password: new FormControl("",[Validators.required, Validators.minLength(8), Validators.maxLength(40)]),
      confirmPassword: new FormControl("",[Validators.required, Validators.minLength(8), Validators.maxLength(40)])
    },{
      validator: this.passwordConfirming
    });
  }

  passwordConfirming(c: AbstractControl): { mismatch: boolean } {
    if (c.get('password').value !== c.get('confirmPassword').value) {
        return {mismatch: true};
    }
}


  ngOnDestroy(): void {}

}
